/*
 * capitalizeWords replaces the `capitalize` npm package (v2.0.4), removed under
 * 3PP-Reduce (W-24077647), using only String.prototype built-ins. Same word-char
 * set as capitalize.words(): ASCII alphanumerics + Latin-1/Extended-A accented
 * letters + Cyrillic; everything else is a separator, preserved verbatim.
 *
 * One intentional behavior difference from the removed library: an embedded
 * quote (e.g. the apostrophe in "o'brien") is now treated as a word boundary,
 * so it renders "O'Brien" instead of the library's "O'brien" — arguably more
 * correct for a display name, and this field is display-only.
 */
const WORD_BOUNDARY = /(^|[^0-9a-zA-ZÀ-ſЀ-ӿ])([0-9a-zA-ZÀ-ſЀ-ӿ])/g;

export default function capitalizeWords(input) {
  // The old lib threw on non-strings; return the value untouched instead so a
  // null/undefined status can't crash a render.
  if (typeof input !== 'string') {
    return input;
  }

  return input.toLowerCase().replace(WORD_BOUNDARY, (_, sep, ch) => sep + ch.toUpperCase());
}
